import {
  Box,
  Button,
  Divider as MuiDivider,
  Stack,
  styled,
} from '@mui/material';

export const Container = styled(Box)`
  height: 100vh;

  display: flex;
  flex-direction: column;
`;

export const Content = styled(Box)`
  flex: 1;
  overflow-y: auto;
`;

export const Section = styled(Box)`
  display: flex;
  justify-content: space-between;
`;

export const Divider = styled(MuiDivider)`
  margin: 20px 0;
`;

export const LeftContainer = styled(Stack)`
  max-width: 201px;
  width: 100%;
`;

export const StyledDiscardButton = styled(Button)(
  ({ theme }) => ` 
  color: ${theme.palette.brand.charcoal}
`,
);
